
export const colors = {
    primary: "#7a10ff",
    secondary: "#F7ECFEFF",
    background: "#F4F3F3FF",
    white: "#FFFFFF",
    black: "#272729FF",
    gray: "#989898",
    status: {
        red: "#FB5858FF",
        green: "#27AC27FF",
        yellow: "#FFAE00FF",
        blue: "#4F6BF7FF",
    }
}